import SearchBar from "../common/SearchBar";
import SelectField from "../common/SelectField";
import { Plus, ShieldCheck, Files, Filter } from "lucide-react";
import "../../styles/common.css";
import "../../styles/driverHeader.css"; 

export default function DocumentHeader({ 
  total, search, onSearch, onAdd, 
  requiredFilter, onRequiredChange,
  multipleFilter, onMultipleChange
}) {
  
  const requiredOptions = [
    { label: "Tous les types", value: "all" },
    { label: "Obligatoires", value: "true" },
    { label: "Optionnels", value: "false" },
  ];

  const multipleOptions = [
    { label: "Tous les formats", value: "all" },
    { label: "Fichiers multiples", value: "true" },
    { label: "Fichier unique", value: "false" },
  ];

  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <h2>Types de documents</h2>
          <span className="countBadge">{total}</span>
        </div>

        <button className="btnPrimary" onClick={onAdd}>
          Ajouter un type
          <span className="plusIcon">+</span>
        </button>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
      
          <SelectField
            icon={ShieldCheck}
            value={requiredFilter}
            onChange={onRequiredChange}
            options={requiredOptions}
            // placeholder="Obligation"
          />

    
          <SelectField
            icon={Files}
            value={multipleFilter}
            onChange={onMultipleChange}
            options={multipleOptions}
            // placeholder="Nombre de fichiers"
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par nom de document..."
          />
        </div>
      </div>
    </div>
  );
}